module.exports = __webpack_public_path__ + "static/img/3areaA_17.7460234.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/クリスマス/3areaA_17.png
// module id = 846
// module chunks = 1